<template>
  <div class="image-upload-view">
    <div
      class="image-block"
      ref="userProfilePicturePreview">
      <spinner
        class="pfp-spinner"
        v-if="profilePictureLoading"
      />
      <div
        class="profile-picture-placeholder"
        v-if="noPicture"
        v-text="$t('usersInformation.stamp.noImage')"
      />
    </div>
    <input
      ref="imageUploadInput"
      type="file"
      accept=".png"
      @change="loadFilesFromLocalInput"
    />
  </div>
</template>

<script>
import * as stampApi from '../../../../api/stampApi.js'
import * as _ from 'lodash'
import Spinner from '../../../Spinner.vue'
export default {
  name: 'ImageUploadView',
  components: {
    Spinner
  },
  data () {
    return {
      imgurl: '',
      fileInput: Object,
      profilePictureLoading: false,
      noPicture: false,
      userStamp: null
    }
  },
  props: {
    privilegizedEntityId: {
      default: null,
      type: Number
    },
    stampIndex: {
      default: null,
      type: Number
    }
  },
  computed: {
  },
  methods: {
    loadFilesFromLocalInput () {
      let self = this
      let fileStream = self.fileInput.files
      let reader = new FileReader()
      self.profilePictureLoading = true
      reader.onload = e => self.processFileInput(fileStream, e.target.result)
      reader.readAsDataURL(fileStream[0])
    },
    processFileInput (fileStream, readResult) {
      let self = this
      self.profilePictureLoading = false
      self.$refs.userProfilePicturePreview.style.backgroundImage = 'url(' + readResult + ')'
      if (_.size(fileStream) > 0) {
        self.userStamp = fileStream[0]
        self.noPicture = false
        self.$emit('newUserStamp', self.userStamp, self.stampIndex)
      }
    }
  },
  mounted () {
    let self = this
    self.fileInput = self.$refs.imageUploadInput
    self.profilePictureLoading = true
    if (self.privilegizedEntityId != null) {
      stampApi.getStampForUser(self.stampIndex, self.privilegizedEntityId).then(result => {
        let reader = new FileReader()
        reader.onloadend = function () {
          self.profilePictureLoading = false
          if (result.size > 0) {
            self.$refs.userProfilePicturePreview.style.backgroundImage = 'url(' + reader.result + ')'
          } else {
            self.noPicture = true
          }
        }
        reader.readAsDataURL(result)
      })
    } else {
      self.profilePictureLoading = false
      self.noPicture = true
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../../../kit-components/uikit';
  .image-upload-view {
    display: block;
    width: 225px;
    text-align: left;
    .image-block {
      height: 200px;
      width: 200px;
      border: 2px dashed $primaryBorderColor;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .pfp-spinner {
      padding: 40%;
      height: 100%;
    }
    .profile-picture-placeholder {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      pointer-events: none;
      height: 100%;
      width: 100%;
      text-align: center;
      margin-top: calc(50% - 7px);
      font-size: 14px;
      font-weight: lighter;
      color: $primaryBorderColor;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/StampUploadView.vue